<template>
<v-card v-show="shop !== 0" class="dash-card">
    <shop-users ref="shopUsersRef" :shopID="shop" style="display:none"></shop-users>
    <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
        <v-toolbar-title>
            {{getString('I ritardatari (Quelli che non vengono da un po\')')}}
        </v-toolbar-title>
         <v-spacer></v-spacer>
        <v-toolbar-side-icon @click="hidden = !hidden">
          <v-icon class="q-text-whitesmoke" :class="{'module-closed' : !hidden}" >arrow_drop_down</v-icon>
        </v-toolbar-side-icon>
    </v-toolbar>
    <v-layout row wrap v-show="!hidden">
        <v-flex xs12 sm12 md12 lg12>
            <v-card>
                 <v-toolbar class="q-whitesmoke-bk q-text-whitesmoke elevation-0 no-cradius" height="50px">
                   <v-text-field v-model="search" :placeholder="getString('Cerca qui')" />
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <v-flex slot="activator">
                            <v-btn @click="getStats" color="red lighten-2" class="no-cradius elevation-0 q-text-whitesmoke">
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                        <span>{{getString('Aggiorna i dati')}}</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="headers" :items="resStats" :search="search" :rows-per-page-items="[10,25,{text:getString('Tutto'),value:-1}]" :rows-per-page-text="getString('Prenotazioni per pagina')" :no-data-text="getString('Dati non disponibili')"
                        :loading="isLoading" class="elevation-0">
                        <template slot="items" slot-scope="props">
                          <tr style="cursor:pointer" @click="openClientCard(props.item)">
                            <td>
                                <v-list-tile-avatar>
                                    <img :src="defaultAvatar(props.item.photo)">
                                </v-list-tile-avatar>
                            </td>
                            <td class="text-xs-left">{{props.item.uName}} {{props.item.uSurname}}</td>
                            <td class="text-xs-left">{{ ut.itaDate(props.item.dateAndTime) }}</td>
                            <td class="text-xs-left">{{props.item.phone}}</td>
                            <td class="text-xs-left">{{props.item.email}}</td>
                            <td class="text-xs-left">{{props.item.note}}</td>
                           
                           
                          </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</v-card>
</template>

<script>
import ajax from '../../../ajax'
import Utils from '../../../utils'
import Chart from 'chart.js'
import ShopUsers from './ShopUsers'
let ut = new Utils()
export default {
  name: 'StatsShopCard',
  components: { ShopUsers },
  mounted: function() {
    let self = this
  },
  computed: {
    locale: function() {
      return this.$store.state.currentTranslator.locale
    },
    headers: function() {
      let result = []
      let self = this
      if (Object.keys(this.resStats).length > 0) {
        let temp = [
         
          self.getString('Foto:'),
          self.getString('Nome Cliente:uName'),
          self.getString('Ultima prenotazione il:dateAndTime'),
          self.getString('Telefono:phone'),
          self.getString('Email:email'),
          self.getString('Nota'),
         
        ]
        temp.forEach(element => {
          result.push({
            text: self.getString(element.split(':')[0]),
            align: 'left',
            sortable: true,
            value: element.split(':')[1]
          })
        })
        return result
      }
      return []
    }
  },
  data: () => {
    return {
      h: null,
      lasts: [],
      hidden: true,
      shop: 0,
      isLoading: '',
      search: '',
      resStats: [],
      ut: new Utils()
    }
  },
  methods: {
    defaultAvatar: function(url) {
      if (
        url === null ||
        url === 'images/u_placeholder.jpg' ||
        url === '/images/u_placeholder.jpg'
      ) {
        return (
          '/../../../../static/img/default-avatar.png'
        )
      } else return ajax.baseUrl() + url
    },
    setVisibility: function(vis) {
      this.hidden = vis
    },
    getStats: function() {
      let self = this
      this.isLoading = true
      ajax.axios
        .get(ajax.baseUrl() + '/admin/dashboard/trends/lasts/shop/' + self.shop, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.isLoading = false
          self.resStats = response.data.data
        })
        .catch(function(error) {
          self.EmployeeCard.empLoading = false
          var auth = ajax.checkAuth(error, self.$store, self.$router)
        })
    },
    init: function(shop) {
      this.shop = shop
      if (this.shop !== 0) {
        this.getStats()
      }
    },
    openClientCard: function(item) {
      this.$refs.shopUsersRef.openDetails({ idUser: item.referenceUsers })
    },
    getString: function(key) {
      return this.$store.state.currentTranslator.getString(key)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/backend/pieces/StatsLastsCard.vue